import { StyleSheet, Dimensions } from 'react-native';

const { width: SCREEN_WIDTH } = Dimensions.get('window');

export const createStyles = (width: number = SCREEN_WIDTH, height: number = 200) => StyleSheet.create({
    // 容器
    container: {
        width,
        height,
        overflow: 'hidden',
    },
    
    // 内容区域
    contentContainer: {
        position: 'relative',
        width,
        height,
    },
    
    // ScrollView
    scrollView: {
        width,
        height,
    },
    
    scrollContent: {
        flexDirection: 'row',
        height,
    },
    
    scrollContentVertical: {
        flexDirection: 'column',
        width,
    },
    
    // 轮播项
    slideItem: {
        width,
        height,
        justifyContent: 'center',
        alignItems: 'center',
    },
    
    slideItemVertical: {
        width,
        height,
    },
    
    // 图片
    image: {
        width: '100%',
        height: '100%',
    },
    
    // 图片占位
    placeholder: {
        width: '100%',
        height: '100%',
        backgroundColor: '#F5F5F5',
        justifyContent: 'center',
        alignItems: 'center',
    },
    
    placeholderText: {
        fontSize: 14,
        color: '#999',
    },
    
    // 标题区域
    titleContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        paddingHorizontal: 16,
        paddingVertical: 12,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    
    titleContainerOutside: {
        position: 'relative',
        backgroundColor: 'transparent',
        paddingTop: 8,
        paddingBottom: 0,
    },
    
    title: {
        fontSize: 16,
        fontWeight: '600',
        color: '#FFFFFF',
    },
    
    titleOutside: {
        color: '#333333',
    },
    
    subtitle: {
        fontSize: 13,
        color: 'rgba(255, 255, 255, 0.85)',
        marginTop: 4,
    },
    
    subtitleOutside: {
        color: '#666666',
    },
    
    // ==================== 指示器样式 ====================
    indicatorContainer: {
        position: 'absolute',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    
    indicatorBottom: {
        left: 0,
        right: 0,
        bottom: 12,
    },
    
    indicatorTop: {
        left: 0,
        right: 0,
        top: 12,
    },
    
    indicatorLeft: {
        top: 0,
        bottom: 0,
        left: 12,
        flexDirection: 'column',
    },
    
    indicatorRight: {
        top: 0,
        bottom: 0,
        right: 12,
        flexDirection: 'column',
    },
    
    indicatorBottomLeft: {
        bottom: 12,
        left: 16,
    },
    
    indicatorBottomRight: {
        bottom: 12,
        right: 16,
    },
    
    indicatorTopLeft: {
        top: 12,
        left: 16,
    },
    
    indicatorTopRight: {
        top: 12,
        right: 16,
    },
    
    // 点状指示器
    dot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        marginHorizontal: 3,
    },
    
    dotActive: {
        backgroundColor: '#FFFFFF',
    },
    
    dotVertical: {
        marginHorizontal: 0,
        marginVertical: 3,
    },
    
    // 线状指示器
    line: {
        width: 16,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        marginHorizontal: 2,
    },
    
    lineActive: {
        backgroundColor: '#FFFFFF',
    },
    
    // 数字指示器
    numberIndicator: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 10,
    },
    
    numberText: {
        fontSize: 12,
        color: '#FFFFFF',
        fontWeight: '500',
    },
    
    // 进度条指示器
    progressContainer: {
        width: 60,
        height: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        borderRadius: 1,
        overflow: 'hidden',
    },
    
    progressBar: {
        height: '100%',
        backgroundColor: '#FFFFFF',
        borderRadius: 1,
    },
    
    // ==================== 箭头样式 ====================
    arrowContainer: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
    },
    
    arrowLeft: {
        left: 8,
    },
    
    arrowRight: {
        right: 8,
    },
    
    arrowLeftOutside: {
        left: -40,
    },
    
    arrowRightOutside: {
        right: -40,
    },
    
    arrowButton: {
        width: 32,
        height: 32,
        borderRadius: 16,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    
    arrowButtonPressed: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    
    arrowIcon: {
        fontSize: 18,
        color: '#FFFFFF',
        fontWeight: 'bold',
    },
    
    arrowBottomContainer: {
        position: 'absolute',
        bottom: 12,
        left: 0,
        right: 0,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 16,
    },
    
    // ==================== 卡片模式样式 ====================
    cardModeContainer: {
        overflow: 'visible',
    },
    
    cardItem: {
        borderRadius: 12,
        overflow: 'hidden',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
        elevation: 5,
    },
    
    cardItemSide: {
        opacity: 0.7,
    },
    
    // ==================== 触摸覆盖层 ====================
    touchOverlay: {
        ...StyleSheet.absoluteFillObject,
    },
    
    // ==================== 懒加载占位 ====================
    lazyPlaceholder: {
        width: '100%',
        height: '100%',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

// 指示器位置样式键类型
export type IndicatorPositionStyleKey =
    | 'indicatorBottom'
    | 'indicatorTop'
    | 'indicatorLeft'
    | 'indicatorRight'
    | 'indicatorBottomLeft'
    | 'indicatorBottomRight'
    | 'indicatorTopLeft'
    | 'indicatorTopRight';

// 获取指示器位置样式
export const getIndicatorPositionStyle = (position: string): IndicatorPositionStyleKey => {
    const positionMap: Record<string, IndicatorPositionStyleKey> = {
        'bottom': 'indicatorBottom',
        'top': 'indicatorTop',
        'left': 'indicatorLeft',
        'right': 'indicatorRight',
        'bottom-left': 'indicatorBottomLeft',
        'bottom-right': 'indicatorBottomRight',
        'top-left': 'indicatorTopLeft',
        'top-right': 'indicatorTopRight',
    };
    return positionMap[position] || 'indicatorBottom';
};

// 默认主题颜色
export const defaultColors = {
    indicatorActive: '#FFFFFF',
    indicatorInactive: 'rgba(255, 255, 255, 0.5)',
    arrowBackground: 'rgba(0, 0, 0, 0.3)',
    arrowColor: '#FFFFFF',
    titleBackground: 'rgba(0, 0, 0, 0.4)',
    titleColor: '#FFFFFF',
};
